<template>
  <div class="edit-nikud-popup-l" v-hotkey="keymap">
    <b-modal size="lg" centered
        footer-class="edit-nikud-footer"
        v-model="editNikudProps.showEditNikud">
      <div slot="modal-header">
        <i-pencil-alt></i-pencil-alt>
        <span class="modal-header-title">
          {{hebrew ? 'עריכת טקסט' : 'Edit text'}}
        </span>
      </div>
    <!-- <p class="clear-nikud" @click="clearNikudFromAlreadyInitializedWorkingWord">נקה ניקוד</p> -->
    <!-- (this input is now NEVER being used!)
    <input v-if="!showWordBeforeAndAfter && localCurrentWordIndex > -1" 
      :value="display(workingWord, false)" 
      @input="workingWord = $event.target.value; useNewVersion()"
      class="nikud-manual-edit-area" />
    -->
    <textarea
      v-if="showWordBeforeAndAfter && localCurrentWordIndex > -1"
      v-model="workingWord" class="nikud-manual-edit-area text-right" dir="rtl"/>
    <p v-if="hebrew">כדי לערוך יותר ממילה אחת,
       בחרו עם העכבר את המילים שאתם רוצים לערוך ולחצו על ״ערוך טקסט״ או Shift+E
    <br />** הטקסט כאן הוא הטקסט המקורי שלך לפני פיענוח הראשי תיבות</p>
    <p v-else>
      To edit multiple words, 
      Select the words to edit with the mouse and click on "Edit text" or on Ctrl+e.
      <br />** The text that appears in the text area is the original text before expansion.
    </p>
    <template slot="modal-footer">
      <b-button variant="secondary" @click="editNikudProps.showEditNikud = false">{{hebrew ? 'ביטול' : 'Cancel'}}</b-button>
      <!--
      <b-button v-show="showWordBeforeAndAfter"
        id="edit-apply-button"
        @click="useNewVersion"
        class="mr-0"
        variant="outline-primary">השתמש
      </b-button>
      -->
      <b-button
        class="mr-2"
        variant="primary"
        @click="redoNikudClicked">{{hebrew ? 'השתמש ופענח' : 'Apply and Expand'}}</b-button>
    </template>
    </b-modal>
  </div>
</template>

<script>

import nikudMixins from '@/mixins/nikudMixins'
import resultsIntegrationMixins from '@/mixins/resultsIntegrationMixins'
import navigationMixins from '@/mixins/navigationMixins'
import wordMutatingMixins from '@/mixins/wordMutatingMixins'
import {RunStates} from '@/store/runStates'
import {stringWithoutNikud} from 'shared/js/commonHebrew'
import $ from 'jquery'

export default {
  name: 'EditNikudPane',
  props: ['editNikudProps', 'modesObj'],
  mixins: [
    nikudMixins, /* for the direct use of: localCurrentWordIndex, localCurrentLetterIndex, localCurrentWord, 
                      display(), callForNewNikud(), and getSafeWordAndLetter() */
    resultsIntegrationMixins, // for getNewNikud() and finishEditingWordGroup()
    wordMutatingMixins, /* for the direct use of: rewriteWordOrWordsInWorkingArrayMethod() and
                            spliceWordsInWorkingArrayMethod() ...
                        ...& b/c (now) whoever uses resultsIntegrationMixins needs wordMutatingMixins too */
    navigationMixins // for moveToNextWord()
  ],
  data () {
    return {
      whitespaceAtStartOfWorkingWord: '',
      useOnAllText: false,
      workingWord: '',
      waitingToRedoNikud: false, // ditto
      nakdanCallType: '',
      parText: '',
      parIndices: [],
      showWordBeforeAndAfter: true,
      keymap: {
        // 'shift+enter': () => {
        //   var ta = $('textarea')
        //   if (!(ta.get(0)) || !(ta.is(':focus') && !(ta.parent().is(':focus')))) {
        //     this.useNewVersion()
        //     if (this.localCurrentWordIndex < (this.$store.state.allWorkingNikud.wordsArray.length - 1)) {
        //       this.$store.commit('SET_CURRENT_WORD_INDEX', this.localCurrentWordIndex + 1)
        //       this.$emit('switch-to-options-pane')
        //     }
        //   }
        // },
        'ctrl+i': this.clearNikudFromAlreadyInitializedWorkingWord,
        // 'shift+i': this.clearNikudFromAlreadyInitializedWorkingWord,
        'enter': this.redoNikudClicked,
        // 'alt+shift+enter': this.useNewVersion,
        'escape': () => { this.editNikudProps.showEditNikud = false }
      }
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    localnakdanApiState: function () {
      return this.$store.state.nakdanApiState
    },
    workingIndices () {
      return this.editNikudProps.workingIndices
    }
  },
  watch: {
    localCurrentWord: function () {
      // this.initWorkingWord('to-original-chosen-word-with-nikud')
    },
    localnakdanApiState: function (newLocalnakdanApiState) {
      if (newLocalnakdanApiState === RunStates.COMPLETE) {
        if (this.nakdanCallType === 'redo-nikud') {
          this.finishRedoingNikud()
        } else {
          this.finishEditingWordGroup()
          this.moveAfterEditingWordGroupIfNeeded()
        }
      }
    },
/*    workingWord: function () {
      var ta = $('textarea')
      if (ta.get(0)) {
        var sh = ta.get(0).scrollHeight - 18
        console.log('scrollHeight:')
        console.log(sh)
        var lh = parseInt(ta.css('lineHeight'), 10)
        console.log('lineHeight:')
        console.log(lh)
        var textareaLines = sh / lh
        console.log('textareaLines:')
        console.log(textareaLines)
        ta.css('height', (textareaLines * 30 + 20) + 'px')
      }
    },
*/    showWordBeforeAndAfter: function () {
      // this.initWorkingWord('to-chosen-word-with-nikud')
    }
  },
  methods: {
    clearNikudFromAlreadyInitializedWorkingWord ( /* evt */ ) {
      // if (evt.key === 'I') evt.preventDefault()
      this.workingWord = stringWithoutNikud(this.workingWord)
    },
    initWorkingWord (mode) {
      const firstSepBefore = this.$store.state.allWorkingNikud.wordsArray[this.workingIndices[0]].sepBefore
      const indexOfNonWhitespace = /\S/.test(firstSepBefore) ? firstSepBefore.indexOf(firstSepBefore.trim()) 
        : firstSepBefore.length
      this.whitespaceAtStartOfWorkingWord = firstSepBefore.slice(0, indexOfNonWhitespace)
      this.workingWord = ''
      // this.workingIndices = [this.localCurrentWordIndex]
      // if (this.localCurrentWordIndex > 0) this.workingIndices.unshift(this.localCurrentWordIndex - 1)
      // if (this.localCurrentWordIndex < (this.$store.state.allWorkingNikud.wordsArray.length - 1)) this.workingIndices.push(this.localCurrentWordIndex + 1)
      this.workingIndices.forEach(i => {
        const wordToAdd = this.$store.state.allWorkingNikud.wordsArray[i]
        const sepBeforeToAdd = i === this.workingIndices[0] ? wordToAdd.sepBefore.slice(indexOfNonWhitespace)
          : wordToAdd.sepBefore
        if (mode === 'clear-nikud') {
          this.workingWord += sepBeforeToAdd + this.display(wordToAdd.originalWord) + wordToAdd.sepAfter
        } else {
          this.workingWord += sepBeforeToAdd + this.display(wordToAdd.chosenWordString, false) + wordToAdd.sepAfter
        }
      })
    },
    redoNikudClicked () {
      if (this.showWordBeforeAndAfter) {
        this.waitingToRedoNikud = true
      }
      this.useNewVersion()
      // removed code executed if showWordBeforeAndAfter's false from here (b/c it currently CAN'T be)
    },
    finishRedoingNikud () { // note: this fn's currently NEVER called - if that changes, it'll need
      var newNikud = this.getNewNikud() // rewriting - probably based on getWordsArrayFromNakdanResponse()
      // console.log('newNikud.length:')
      // console.log(newNikud.length)
      const originalWord = this.localCurrentWord.editedNikud // i.e. what was just sent
      const userDictPosQuery = this.localUserDictionary.lettersMap[originalWord]
      const userDictNegQuery = this.localUserDictionary.negativeLettersMap[originalWord]
      const optionsSource = newNikud[this.parIndices.indexOf(this.localCurrentWordIndex)].options
      let o = 0
      if (!userDictPosQuery && userDictNegQuery) {
        while (this.localUserDictionary.negativeEntryPresent[optionsSource[o].displayText]
                && o < optionsSource.length - 1) o += 1
        if (this.localUserDictionary.negativeEntryPresent[optionsSource[o].displayText]) {
          o = optionsSource.map(o => o.displayText).indexOf(userDictNegQuery[0])
        }
      }
      var wordObj = {
        options: optionsSource,
        altered: true, // not 'conditional', because 'invisible data' may have changed
        choiceType: userDictPosQuery ? 'manual' : 'option',
        chosenOptionIndex: o,
        originalWord: originalWord,
        manualNikud: userDictPosQuery ? userDictPosQuery[0] : this.localCurrentWord.options[0].displayText,
        editedNikud: this.localCurrentWord.options[0].displayText
      }
      this.rewriteWordOrWordsInWorkingArrayMethod({
        contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
        newWordContainer: {
          index: this.localCurrentWordIndex, changes: wordObj
        }
      })
      // this.$emit('switch-to-options-pane')
      this.editNikudProps.showEditNikud = false
    },
    setParTextAndParIndices () {
      var thisParIndices = [this.localCurrentWordIndex]
      var thisParText = this.localCurrentWord.sepBefore
      thisParText += this.localCurrentWord.editedNikud
      var checkingWord
      var checkingWordIndex = this.localCurrentWordIndex
      var proceed = true
      while (proceed) {
        checkingWord = this.$store.state.allWorkingNikud.wordsArray[checkingWordIndex]
        if ((checkingWordIndex === 0) || (checkingWord.sepBefore.indexOf('\n') !== -1)) {
          proceed = false
        } else {
          checkingWordIndex -= 1
          // console.log(checkingWordIndex)
          checkingWord = this.$store.state.allWorkingNikud.wordsArray[checkingWordIndex]
          // console.log(checkingWord)
          thisParText = checkingWord.originalWord + thisParText
          thisParText = checkingWord.sepBefore + thisParText
          thisParIndices.unshift(checkingWordIndex)
        }
      }
      checkingWordIndex = this.localCurrentWordIndex + 1
      proceed = true
      while (proceed) {
        if (checkingWordIndex < this.$store.state.allWorkingNikud.wordsArray.length) {
          checkingWord = this.$store.state.allWorkingNikud.wordsArray[checkingWordIndex]
          if (checkingWord.sepBefore.indexOf('\n') !== -1) {
            proceed = false
          } else {
            thisParText += checkingWord.sepBefore
            thisParText += checkingWord.originalWord
            thisParIndices.push(checkingWordIndex)
            checkingWordIndex += 1
          }
        } else proceed = false
      }
      // console.log('thisParText:')
      // console.log(thisParText)
      // console.log('thisParIndices')
      // console.log(thisParIndices)
      this.parText = thisParText
      this.parIndices = thisParIndices
    },
    useNewVersion () {
      if (this.showWordBeforeAndAfter) {
        if (this.workingWord.replace(/[^א-ת]/g, '').length) {
          this.nakdanCallType = 'edit-word-group'
          this.callForNewNikud(this.whitespaceAtStartOfWorkingWord + this.workingWord)
        } else {
          let spliceStart = this.workingIndices[0]
          let toDelete = this.workingIndices.length
          let spliceWords = []
          this.workingWord = this.whitespaceAtStartOfWorkingWord + this.workingWord
          if (this.workingWord) { // i.e. there are separator characters to "reposition"
            let newPosition = this.workingIndices[this.workingIndices.length - 1] + 1
            if (newPosition === this.$store.state.allWorkingNikud.wordsArray.length) {
              newPosition = this.workingIndices[0] - 1
            }
            if (newPosition !== -1) { // because if it's -1 that means there's NOWHERE to put them
              let newWordObjForSepNewPos = Object.assign(
                {}, // so as not to change the separator (& "altered") of the object in the store
                this.$store.state.allWorkingNikud.wordsArray[newPosition],
                { altered: true } // because we're about to do so
              )
              if (newPosition === this.workingIndices[0] - 1) {
                newWordObjForSepNewPos.sepAfter = this.$store.state.allWorkingNikud.wordsArray[newPosition].sepAfter + this.workingWord
                spliceStart--
              } else newWordObjForSepNewPos.sepBefore = this.workingWord + this.$store.state.allWorkingNikud.wordsArray[newPosition].sepBefore
              toDelete++
              spliceWords = [newWordObjForSepNewPos]
            }
          }
          this.spliceWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            spliceWordsContainer: {
              startIndex: spliceStart, toDelete: toDelete, spliceWordsArray: spliceWords
            }
          })
          this.editNikudProps.showEditNikud = false
        }
      } else {
        if (this.localCurrentWord.chosenWordString !== this.workingWord) {
          this.rewriteWordOrWordsInWorkingArrayMethod({
            contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
            newWordContainer: {
              index: this.localCurrentWordIndex, changes: { altered: true } // because we're about to do so
            }
          })
        }
        this.rewriteWordOrWordsInWorkingArrayMethod({
          contextData: { wordIndex: this.localCurrentWordIndex, letterIndex: this.localCurrentLetterIndex }, // for undo
          newWordContainer: {
            index: this.localCurrentWordIndex, changes: { editedNikud: this.workingWord, choiceType: 'edited' }
          }
        })
      }
    },
    blockEnter (e) {
      var keyCode = e.keyCode || e.which
      if (this.editNikudProps.showEditNikud && keyCode == 13 && !(e.shiftKey)) {
        e.preventDefault()
      }
    }
  },
  mounted: function () {
    // if (this.localCurrentWordIndex > -1) {
    this.initWorkingWord('clear-nikud') // ('to-original-chosen-word-with-nikud')('do-not-clear-nikud')
    // }
    $(document).on('keydown keyup keypress', this.blockEnter)
  },
  beforeDestroy () {
    const wordAndLetter = this.getSafeWordAndLetter(this.editNikudProps.workingIndices[0], -1)
    this.$store.commit('SET_WORD_AND_LETTER', {
      word: wordAndLetter.word,
      letter: wordAndLetter.letter
    })        
    $(document).off('keydown keyup keypress', this.blockEnter)
  }
}
</script>

<style lang="scss">
.edit-nikud-popup {
  position: absolute;
  top: 50px;
  left: 180px;
  width: 55vw;
  height: 55vh;
  background-color: white;
  border-style: solid;
  border-color: gray;
  border-width: 1px;
}
.edit-nikud-footer {
  display: block;
  text-align: right;
  direction: rtl; // so cancel button is ALWAYS on the right
  >:not(:last-child) { // ALWAYS "hebrew" style (because of the above)
    margin-left: .25rem;
    margin-right: 0;
  }
  >:not(:first-child) {
    margin-left: 0;
    margin-right: .25rem;
  }
}
body.he .edit-nikud-footer {
  text-align: left;
}
</style>

<style scoped>
.clear-nikud {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 8px;
  font-size: 12px;
  text-align: left;
  cursor: pointer;
}
.nikud-manual-edit-area {
  font-family: mft_narkisclassic, serif;
  font-size: 22px;
  line-height: 30px;
  height: 170px;
  overflow: auto;
  resize: none;
  width: 100%;
  border-radius: 2px;
  outline: none;
  padding: 8px;
  border: 1px solid #aaa;
}
.nikud-manual-edit-area:focus {
  border-color: var(--primary);
}
.show-word-before-and-after {
  margin-right: 8px;
}
.use-on-all-text, .add-to-store {
  margin: 5px;
}
.pane-bottom {
  position: absolute;
  bottom: 10px;
  width: 98%
}
.text-underline-btn{
  padding-left: 6px;
  padding-right: 6px;
  min-width: auto;
}
</style>
